module.exports = __webpack_public_path__ + "img/manufacturing_xugong.ba3b7def.png";